import React from "react";
import styled from "styled-components";
import { rgba } from "polished";

const LoadingFadedDiv = styled.div`
  position: ${(props) => (props.isfull ? "fixed" : "absolute")};
  width: 100%;
  height: 100%;
  z-index: 2080;
  left: 0;
  top: 0;
  display: ${(props) => (props.show ? "block" : "none")};

  background: ${rgba("#fff", 0.3)};
  opacity: 1;
  visibility: visible;
  transition: 0.3s linear;

  div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 350px;
  }

  img {
    width: 30px;
    height: 30px;
    transform: scale(2);
  }

  h5 {
    padding-top: 30px;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    color: #104473;
  }
`;

const LoadingCover = ({ show, isFullScreen = true, desc }) => (
  <LoadingFadedDiv show={show} isfull={isFullScreen}>
    <div>
      <img src="/assets/img/icon-loading-primary.gif" alt="loading..." />
      {desc && <h5>{desc}</h5>}
    </div>
  </LoadingFadedDiv>
);

export default LoadingCover;
